var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#fff","d":"M14 3.5a10.5 10.5 0 1 0 0 21 10.5 10.5 0 0 0 0-21Zm5.367 14.525a.863.863 0 0 1-.7.35.886.886 0 0 1-.525-.175l-4.667-3.5a.865.865 0 0 1-.35-.7V7a.875.875 0 0 1 1.75 0v6.557l4.317 3.243a.875.875 0 0 1 .175 1.225Z"}));
}

Clock.defaultProps = {"viewBox":"0 0 28 28","fill":"none"};

module.exports = Clock;

Clock.default = Clock;
